import type { AutoCompleteItem } from '../../../../components/react-hook-form/AutoCompleteItem.d';
import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { useWatch } from 'react-hook-form';
import { AutoComplete } from '../../../../components/react-hook-form/AutoComplete';
import {
	ANONYMOUS_FIELD_NAME,
	ANONYMOUS_WHERE,
} from '../constants';
import {
	COMMON_FREETEXT_FIELD_NAME,
	WHERE_LEGEND_ID,
} from '../../common/constants';

const OTHER: string[] = [
	ANONYMOUS_WHERE.OTHER,
];

export const WhereAutoComplete = ({
	descriptionId,
	errorSummaryLabel,
	items,
	phrases,
}: {
	descriptionId: string;
	errorSummaryLabel: string;
	items: AutoCompleteItem[];
	phrases: Phrases;
}): React.JSX.Element => {
	const { control, setValue } = useFormContext();

	const where = useWatch({ control, name: ANONYMOUS_FIELD_NAME.WHERE }) as string;

	React.useEffect(() => {
		if (!where || !OTHER.includes(where)) {
			// Yes, empty string can be set on optional text fields.
			setValue(COMMON_FREETEXT_FIELD_NAME.WHERE_OTHER, '', { shouldValidate: true });
		}
	}, [where]);

	const label = phrases['notificationForm.anonymous.whereField.label'];

	return (
		<AutoComplete
			aria-labelledby={WHERE_LEGEND_ID}
			aria-describedby={descriptionId}
			errorSummaryLabel={errorSummaryLabel}
			fullWidth={false}
			hideLabel
			label={label}
			name={ANONYMOUS_FIELD_NAME.WHERE}
			items={items}
		/>
	);
};
